import React from 'react'
import { Grid, Typography } from '@mui/material'
import ParameterFormView from './ParameterFormView'
import LanguageStrings from '../../../../i18n/locales'

const customKpi = LanguageStrings().ThermalIQStrings.CreateCustomKpiComponent

interface StageFormProps {
  index: number
  stage: any
  calculatedName: string
  isAssetLevel: boolean
  getStageValue: number | null
  scaleFator: any
  totalizePeriod: string
  totalizeType: string
}

const StageFormView: React.FC<StageFormProps> = ({
  index,
  stage,
  calculatedName,
  isAssetLevel,
  getStageValue, scaleFator, totalizePeriod, totalizeType
}) => {
  const isCalculatedParameter = index > 0
  const commonStyles = {
    color: '#F0F0F0',
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontFamily: '"Honeywell Sans Web"',
    fontSize: '16px',
    fontStyle: 'normal',
    lineHeight: '24px',
    letterSpacing: '0.5px'
  }
  console.log('stage', stage, index, totalizePeriod, getStageValue, calculatedName)
  return (
    <>
      <Grid spacing={4} sx={{ display: 'flex', gap: '16px', justifyContent: 'space-between', flexDirection: 'column', marginBottom: '12px' }}>
        {isCalculatedParameter
          ? (
              <Grid item>
                <div style={{ width: '318px', gap: '0px', borderRadius: '5px', background: '#202020', flexShrink: '0', padding: '10px' }}>
                  <Typography style={{ ...commonStyles, fontWeight: 500 }}>{(calculatedName !== undefined && calculatedName !== null && calculatedName !== '') ? calculatedName : customKpi.CalculatedParameterValue}</Typography>
                  <Typography style={{ ...commonStyles, fontWeight: 600 }}>
                    {getStageValue === null ? 'NaN' : getStageValue}
                  </Typography>
                </div>
              </Grid>
            )
          : (
              stage?.kpi_parameters[0].parameter_type !== 'NO_CONDITION'
                ? (
                    <Grid item>
                      <ParameterFormView fieldKey={'parameter1'} operator={stage?.operator_type} stageParameter={stage?.kpi_parameters[0]} isAssetLevel={isAssetLevel}/>
                    </Grid>
                  )
                : null
            )
        }
        {
          stage !== undefined
            ? (
                isCalculatedParameter
                  ? (
                    <Grid item>
                      <ParameterFormView fieldKey={'parameter1'} operator={stage?.operator_type} stageParameter={stage?.kpi_parameters[0]} isAssetLevel={isAssetLevel}/>
                    </Grid>
                    )
                  : (
                    <Grid item>
                      <ParameterFormView fieldKey={'parameter2'} operator={stage?.operator_type} stageParameter={stage?.kpi_parameters[1]} isAssetLevel={isAssetLevel}/>
                    </Grid>
                    )
              )
            : null
        }
      </Grid>
      {
        stage !== undefined
          ? (
              stage?.operator_type === 'TOTALIZER'
                ? (
                  <Grid container spacing={2} style={{ display: 'flex', marginLeft: '32px', flexDirection: 'column', width: '310px', marginRight: '32px', borderRadius: '5px', background: '#202020', padding: '10px' }}>
                    <Grid item style={{ marginBottom: '10px' }}>
                      <Typography style={{ ...commonStyles, fontWeight: 500 }}>Scale Factor</Typography>
                      <Typography style={{ ...commonStyles, fontWeight: 600 }}>{scaleFator}</Typography>
                    </Grid>
                    <Grid item style={{ marginBottom: '10px' }}>
                      <Typography style={{ ...commonStyles, fontWeight: 500 }}>Totalize Period</Typography>
                      <Typography style={{ ...commonStyles, fontWeight: 600 }}>{totalizePeriod}</Typography>
                    </Grid>
                    <Grid item>
                      <Typography style={{ ...commonStyles, fontWeight: 500 }}>Totalizer Type</Typography>
                      <Typography style={{ ...commonStyles, fontWeight: 600 }}>{totalizeType}</Typography>
                    </Grid>
                  </Grid>
                  )
                : (
                  <Grid spacing={2} style={{ display: 'flex', alignItems: 'center', padding: '0 100px 0 100px' }}>
                    <Grid item style={{ width: '210px', height: '70px', gap: '0px', borderRadius: '5px', background: '#202020', flexShrink: '0', padding: '10px' }}>
                      <Typography style={{ ...commonStyles, fontWeight: 500 }}>
                        {stage?.operator_type === 'ARITHMETIC' ? customKpi.ArithmeticIndicator : customKpi.LogicalIndicator}
                      </Typography>
                      <Typography style={{ ...commonStyles, fontWeight: 600 }}>
                        {stage?.operator}
                      </Typography>
                    </Grid>
                  </Grid>
                  )
            )
          : null
      }
    </>
  )
}

export default StageFormView
